import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1fcc6564&scoped=true&"
import script from "./Header.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Header.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=1fcc6564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc6564",
  null
  
)

export default component.exports